import adpRateMappingSlice from './adpRateMappingSlice';
import behaviorReductionSlice from './behaviorReductionSlice';
import billingSlice from './billingSlice';
import calendarSlice from './calendarSlice';
import calendarHelperSlice from './calendarHelperSlice';
import clientProgramSlice from './clientProgramSlice';
import clientSlice from './clientSlice';
import clientInsuranceSlice from './clientInsuranceSlice';
import dataCollectionSlice from './dataCollectionSlice';
import graphAnnotationSlice from './graphAnnotationSlice';
import graphSlice from './graphSlice';
import programTargetSlice from './programTargetSlice';
import sessionSlice from './sessionSlice';
import skillAreaSlice from './skillAreaSlice';
import soapNoteSlice from './soapNoteSlice';
import userClientSlice from './userClientSlice';
import excelReportSlice from './excelReport';
import insuranceAuthorizationSlice from './insuranceAuthorizationSlice';
import branchSlice from './branchSlice';
import dashboardSlice from './dashboardSlice';
import insuranceSlice from './insuranceSlice';
import recurringScheduleSlice from './recurringScheduleSlice';
import scheduleCancellationSlice from './scheduleCancellationSlice';
import scheduleReportSlice from './scheduleReportSlice';
import fundingSlice from './fundingSlice';
import mondaySyncSlice from './mondaySyncSlice';

const Client = {
	adpRateMapping: adpRateMappingSlice,
	mondaySync: mondaySyncSlice,
	behaviorReduction: behaviorReductionSlice,
	billing: billingSlice,
	calendar: calendarSlice,
	client: clientSlice,
	clientProgram: clientProgramSlice,
	dataCollaction: dataCollectionSlice,
	graph: graphSlice,
	graphAnnotation: graphAnnotationSlice,
	programTarget: programTargetSlice,
	session: sessionSlice,
	skillArea: skillAreaSlice,
	soapNote: soapNoteSlice,
	userClient: userClientSlice,
	excelReport: excelReportSlice,
	calendarHelper: calendarHelperSlice,
	authorization: insuranceAuthorizationSlice,
	branch: branchSlice,
	dashboard: dashboardSlice,
	clientInsurance: clientInsuranceSlice,
	insurance: insuranceSlice,
	recurringSchedule: recurringScheduleSlice,
	scheduleCancellation: scheduleCancellationSlice,
	scheduleReport: scheduleReportSlice,
	funding: fundingSlice,
};

export default Client;
